import React from "react";
import { NewEmailLayoutContainer } from "../../../containers";

const NewEmailLayout = (props) => {
  return <NewEmailLayoutContainer {...props} />;
};

export default NewEmailLayout;
